import { render, staticRenderFns } from "./PurchasesDeliveryViewGlobal.vue?vue&type=template&id=04282b48"
import script from "./PurchasesDeliveryViewGlobal.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports